import { Skeleton, SkeletonProps } from "antd";
import { fatchImages } from "assets/customAssets";
import "./LoadingScheleton.css";

const LoadingScheleton: React.FC<SkeletonProps> = ({ className, ...props }) => {
    const {LogoScheleton} =fatchImages();
	return (
		<div className={"loading-scheleton-continer" + (className ? " " + className : "")}>
			<Skeleton.Node {...props} className="loading-scheleton">
				<img src={LogoScheleton} alt="Logo" className="loading-scheleton-image" />
			</Skeleton.Node>
		</div>
	);
};

export default LoadingScheleton;
